import { useEffect, useCallback, useState } from "react";
import store, { actions, useTypedSelector } from "@/stores";
import _ from "lodash";
import { submit as _submit } from "@form/services/campaign";

export default function useVerifyClaim(field?: string) {
  const { result, form } = useTypedSelector((state) => {
    return state.claimVerify;
  });

  useEffect(() => {
    if (field) {
      store.dispatch(actions.claimVerify.register(field));
      return () => {
        store.dispatch(actions.claimVerify.unRegister(field));
      };
    }
  }, [field]);

  const changeForm = useCallback(
    (value: any) => {
      if (field) {
        store.dispatch(
          actions.claimVerify.changeForm({
            field,
            value,
          })
        );
      }
    },
    [field]
  );

  const changeFormField = useCallback((key: string, value: any) => {
    if (field) {
      store.dispatch(
        actions.claimVerify.changeForm({
          field: key,
          value,
        })
      );
    }
  }, []);

  const changeVerifyState = useCallback(
    (state: boolean) => {
      if (field) {
        console.log("changeVerifyState", field, state);
        store.dispatch(
          actions.claimVerify.changeVerifyState({
            field,
            state,
          })
        );
      }
    },
    [field]
  );

  let verified = true;
  for (let prop in result) {
    if (!result[prop]) {
      verified = false;
      break;
    }
  }

  return {
    changeVerifyState,
    changeFormField,
    result,
    verified,
    changeForm,
    form,
  };
}
